import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, FormGroup, Form, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';
import 'whatwg-fetch';
import printerIcon from '../media/printIcon.png';

let recaptchaInstance;

export default class Tour extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      prefersEmail: false,
      prefersPhone: false,
      captcha: "",
      nameValidated: false,
      emailValidated: false,
      phoneValidated: false,
      messageValidated: false,
      captchaValidated: false,
      allButCaptchaValidated: false,
      formCanSubmit: false,
      formSubmitFailed: false,
      formSubmitted: false,
      tourInfoList: [],
      lightboxOpen: false,
      lightboxIndexToOpen: 0
    };
  }

  componentWillMount() { this.setTourPicsList(); }

  setTourPicsList = () => {
    axios.get('https://s3.amazonaws.com/pattersonmaplefarmsstorage/tour/TourInfo.json')
      .then(response => {
        this.setState({
          tourInfoList: response.data
        });
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  tourPicClick = (tourPicIndex) => {
    this.setState({ lightboxIndexToOpen: tourPicIndex, lightboxOpen: true })
  }

  printInLightbox = () => {
    let recipePrintElement = document.getElementsByClassName("ril-image-current ril__image");
    let printArea = window.open('', 'PRINT', 'height=607,width=788');
    printArea.document.write('<html><head><title>' + document.title  + '</title>');
    printArea.document.write('</head><body >');
    //printArea.document.write('<h1>' + document.title  + '</h1>');
    printArea.document.write('</head><body >');
    printArea.document.write(`<img src='${this.state.tourInfoList[this.state.lightboxIndexToOpen].imgURL}'></img>`);
    printArea.document.write('</body></html>');
    printArea.document.close();
    printArea.focus();
    printArea.print();
    printArea.close();
  }

  setInputState = (event) => { this.setState({ [event.target.name]: event.target.value }, () => { this.setValidationState() }); }

  setCaptchaState = (value) => {
    // If user correctly solves captcha, then sits idle, it will become null. Reset it in that case.
    if(value == null) {
      recaptchaInstance.reset();
      this.setState({
         captcha: ""
      }, () => { this.setValidationState(); })
    }
    else {
      this.setState({
         captcha: value
      }, () => { this.setValidationState(); })
    }
  }

  canFormSubmit = () => {
    let allButCaptchaValidated = false;
    let formCanSubmit = false;

    this.state.nameValidated && this.state.emailValidated && 
    this.state.phoneValidated && this.state.messageValidated
    ? allButCaptchaValidated = true : allButCaptchaValidated = false;

    this.state.nameValidated && this.state.emailValidated && 
    this.state.phoneValidated && this.state.messageValidated && this.state.captchaValidated 
    ? formCanSubmit = true : formCanSubmit = false;

    this.setState({ allButCaptchaValidated, formCanSubmit });
  }

  setValidationState = () => {
    let nameValidated = false;
    let emailValidated = false;
    let phoneValidated = false;
    let messageValidated = false;
    let captchaValidated = false;
  
    this.state.name.length > 0 && this.state.name != null ? nameValidated = true : nameValidated = false;
    this.validateEmail(this.state.email) ? emailValidated = true : emailValidated = false;
    this.validatePhone(this.state.phone) ? phoneValidated = true : phoneValidated = false;
    this.state.message.length > 0 && this.state.message != null ? messageValidated = true : messageValidated = false;
    this.state.captcha.length > 0 && this.state.captcha != null ? captchaValidated = true : captchaValidated = false;

    this.setState({ nameValidated, emailValidated, phoneValidated, messageValidated, captchaValidated
    }, () =>  { this.canFormSubmit(); })
  }

  submitForm = () => {
    const currentFields = `Name: ${this.state.name}, Validated: ${this.state.nameValidated}
                          \nEmail: ${this.state.email}, Validated: ${this.state.emailValidated}
                          \nMessage: ${this.state.message}, Validated: ${this.state.messageValidated}
                          \nP_Email: ${this.state.prefersEmail}
                          \nP_Phone: ${this.state.prefersPhone}
                          \nCaptcha: ${this.state.captcha}, Validated: ${this.state.captchaValidated}
                          `;


      this.state.formCanSubmit
      ? this.successfulFormSubmit(currentFields)
      : this.failedFormSubmit()
  }

  successfulFormSubmit(currentFields) {
    //console.log("Submitting the following: " + currentFields);
    this.sendEmail();
    recaptchaInstance.reset();

    this.setState({
        formSubmitted: true,
        formSubmitFailed: false,
        formCanSubmit: false,
        name: "",
        email: "",
        phone: "",
        message: "",
        prefersEmail: false,
        prefersPhone: false,
        captcha: "",
        nameValidated: false,
        emailValidated: false,
        phoneValidated: false,
        messageValidated: false,
        captchaValidated: false,
        allButCaptchaValidated: false,
    });

  }
  failedFormSubmit = () => {
    console.log("One or more fields have an error. Please enter values according to the errors given above.")

    this.setState({
      formSubmitted: false,
      formSubmitFailed: true
    });
  }

  sendEmail = () => {
    var URL = 'https://tc2jqitrp6.execute-api.us-east-1.amazonaws.com/prod/tour';
         
    var emailData = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
      prefersEmail: this.state.prefersEmail,
      prefersPhone: this.state.prefersPhone
    };

    fetch(URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: JSON.stringify({emailData})
    })
    .then(function (response) {
      //console.log('Response: ' + response.json());
    })
    .then(function (result) {
      //console.log('Result: ' + result);
    })
    .catch(function(error) {
      //console.log('Error: ' + error);
    });
  }

  validateEmail = (value) => {
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(value);
  }
  validatePhone = (value) => {
    var validated = false;
    if(value.length > 6 && value.length < 20)
    {
      return value.match(/\d/g);
    }

    return validated;
  }

  render() {
    //const ExampleObject = ( <div></div> );
    const TourPicsView = this.state.tourInfoList.map((tourInfo, index, array) => {
        return <TourImgCol xs="12" sm="6" lg="3" key={index} 
          onClick={() => this.tourPicClick(index)}>
            <img src={tourInfo.imgURL}></img>
        </TourImgCol>
    });

    const PrinterToolbarButton_ForLightBox = (
      <Button style={{width: "28px", height: "33px", cursor: "pointer", 
                    backgroundImage: `url(${printerIcon})`, backgroundPosition: "center", backgroundRepeat: "no-repeat"}} 
              src={require("../media/printIcon.png")}
              onClick={() => this.printInLightbox() } >
      </Button>
    );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>Schedule Tour - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
          <h1>Tour Patterson Farms</h1>
          <p>Free maple tasting and samples are included in the educational exploration! All ages are welcome. 
             Please fill out the form below with any inquiries. We'd love to see you there!</p>

          <AboveFormHR />
          <Form_s autoComplete="on">
            <FormGroup row>
              <Col xs="12" md="4" 
                  className={this.state.formSubmitFailed && !this.state.nameValidated ? "has-danger" : ""}>
                <Input name="name" placeholder="Name" 
                  state={this.state.formSubmitFailed && !this.state.nameValidated ? "danger" : ""}
                  value={this.state.name} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.nameValidated ? 'block' : 'none'}}>
                  Please enter your name.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.emailValidated ? "has-danger" : ""} >
                <Input name="email" type="email" placeholder="Email Address" 
                  state={this.state.formSubmitFailed && !this.state.emailValidated ? "danger" : ""}
                  value={this.state.email} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.emailValidated ? 'block' : 'none'}}>
                  Please enter your email address.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.phoneValidated ? "has-danger" : ""} >
                <Input name="phone" placeholder="Phone Number" type="tel"
                  state={this.state.formSubmitFailed && !this.state.phoneValidated ? "danger" : ""}
                  value={this.state.phone} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.phoneValidated ? 'block' : 'none'}}>
                  Please enter your phone number.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col xs="12" md="12"
                className={this.state.formSubmitFailed && !this.state.messageValidated ? "has-danger" : ""} >
                <Input name="message" placeholder="Question or Message" type="textarea"
                  state={this.state.formSubmitFailed && !this.state.messageValidated ? "danger" : ""}
                  value={this.state.message} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.messageValidated ? 'block' : 'none'}}>
                  Please enter the question or message you would like to send us.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row className="mt-3">
              <Col xs="5" sm="5" md="5" lg="4">
                <p>How would you prefer to be contacted?</p>
              </Col>
              <Col xs="3" sm="2" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbEmail">
                    <Input type="checkbox" id="cbEmail" checked={this.state.prefersEmail} 
                      onClick={ () => { this.setState({prefersEmail: !this.state.prefersEmail}); }}  /> 
                    {' '} Email
                  </Label>
                </FormGroup>
              </Col>
              <Col xs="4" sm="3" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbPhone">
                    <Input type="checkbox" id="cbPhone" checked={this.state.prefersPhone}
                      onClick={ () => { this.setState({prefersPhone: !this.state.prefersPhone}); }}  /> 
                    {' '} Phone
                  </Label>
                </FormGroup>
              </Col>
            </FormGroup>
            <FormGroupLast row>
              <CaptchaCol xs="12"
                className={this.state.formSubmitFailed && !this.state.captchaValidated &&
                       this.state.allButCaptchaValidated ? "has-danger" : ""} >
                <ReCAPTCHA id="captcha"
                  style={{display: !this.state.allButCaptchaValidated ? 'none' : 'block'}}
                  ref={e => recaptchaInstance = e}
                  sitekey="6LciHkQUAAAAAFMMEDt7jqLAPBZ_k6efeMuwGZGK"
                  onChange={this.setCaptchaState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.captchaValidated && 
                                      this.state.allButCaptchaValidated ? 'block' : 'none'}}>
                  Please successfully complete the captcha.
                </FormFeedback>
              </CaptchaCol>
              <SendBtnCol xs="12">
                <Button type="button" onClick={this.submitForm}>
                  <p>SEND</p>
                </Button>
                <LeavesByButton src={require("../media/leavespng1.png")}></LeavesByButton>
              </SendBtnCol>
            </FormGroupLast>
            <FormGroupSubmissionResultRow row className="mb-0">
              <Col xs="12">
                <SuccessfulSubmissionP style={{display: !this.state.formSubmitted ? 'none' : 'block'}} >
                  Message has been sent successfully. Thank you!</SuccessfulSubmissionP>
                <p style={{display: !this.state.formSubmitFailed ? 'none' : 'block'}} className="text-danger">
                  One or more fields have not been filled out correctly. 
                  Please review them and try to send again.</p>
              </Col>
            </FormGroupSubmissionResultRow>
          </Form_s>
          {/*
          <TourImgsDiv>
            <Row>
              {TourPicsView}
            </Row>
          </TourImgsDiv>
        */}
        </InternalContainer>

        {this.state.lightboxOpen ? 
          <Lightbox id="lightboxTourID" mainSrc={this.state.tourInfoList[this.state.lightboxIndexToOpen].imgURL} 
            nextSrc={this.state.tourInfoList[(this.state.lightboxIndexToOpen + 1) % this.state.tourInfoList.length].imgURL}
            prevSrc={this.state.tourInfoList[(this.state.lightboxIndexToOpen + this.state.tourInfoList.length - 1) % this.state.tourInfoList.length ].imgURL}
            onCloseRequest={() => this.setState({lightboxOpen: false})} 
            onMovePrevRequest={ () => this.setState({ lightboxIndexToOpen: (this.state.lightboxIndexToOpen + this.state.tourInfoList.length - 1) % this.state.tourInfoList.length }) }
            onMoveNextRequest={ () => this.setState({ lightboxIndexToOpen: (this.state.lightboxIndexToOpen + 1) % this.state.tourInfoList.length }) } 
            imageTitle={ this.state.tourInfoList[this.state.lightboxIndexToOpen].name }
            toolbarButtons={[ PrinterToolbarButton_ForLightBox ]} />
          
        : ""
        }
      </FluidContainer>
		);
	}
}

const TourImgCol = styled(Col)`
  cursor: pointer;
  transition: all 0.5s;
  :hover { transform: translateY(6px); }
`;

const TourImgsDiv = styled.div`
  .row {
    .col-12 {
      margin: 0 0 30px 0;
    }
  }
  img {
    height: auto;
    width: 100%;
  }
`;

const LeavesByButton = styled.img`
  width: 80px;
  float: right;
  margin-top: -19px;
  display: inline;
`;

const SuccessfulSubmissionP = styled.p`
  color: green;
`;

const AboveFormHR = styled.hr` border-top-width: 2px; margin: -10px 0 0 0; `;
const BelowFormHR = styled.hr` border-top-width: 2px; margin: 0 0 24px 0; `;

const FormGroupSubmissionResultRow = styled(FormGroup)` text-align: center;` ;

const CaptchaCol = styled(Col)`
    padding: 0;
    margin: 20px 15px 0 15px;
    transform: scale(0.77);
    transform-origin: 0 0;
`;

const SendBtnCol = styled(Col)`
  Button {
    cursor: pointer;
    display: inline-block;
    border: 0px!important;
    color: white!important;
    font-weight: bold!important;
    background-color: #800000!important;
    width: 180px!important;
    height: 40px!important;
    line-height: 20px!important;
    transition: all 0.5s;

    p {
      cursor: pointer;
      display: inline;
      position: relative;
      transition: 0.5s;
    }

    p:after {
      content: '\00bb';
      position: absolute;
      opacity: 0;
      transition: 0.5s;
      right: -20px;
    }

    :hover p { padding-right: 25px; }
    :hover p:after { opacity: 1; right: 0; }

    :active p:after { opacity: 0; }
    :active { box-shadow: 0 5px #666; transform: translateY(6px); }
  }
`;

const FormGroupLast = styled(FormGroup)`
    margin-bottom: 0;
    padding-bottom: 15px;
`;

const Form_s = styled(Form)`
    text-align: left;
    font-size: 18px;
    margin-top: 30px;

    .row {
      margin-bottom: 0;
      
      .col-12 {
        margin-bottom: 10px;

        input, textarea {
          border-style: none none solid none;
          border-color: black black black black;
          border-radius: 0;
          background-color: transparent;
          padding-left: 0;
          font-family: 'Short Stack';
          font-size: 18px;
          box-shadow: none;
          color: black;

          :-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:active, :-webkit-autofill:focus { transition: background-color 5000s ease-in-out 0s; }

          &::placeholder {
            color: #464a4c;
          }
        } 
      }
    }
`;

const LocationInfoDiv = styled.div`
  p {
    margin: 0;
  }
`;

const FluidContainer = styled(Container)` padding: 30px 0 0 0!important;  `;
const InternalContainer = styled(Container)` h1 {color: black!important;}  `;


// WEBPACK FOOTER //
// ./src/pages/Tour.js